import { isAxiosError } from 'axios';

/**
 * Logs an error message to the console.
 * @param title - The title or context of the error.
 * @param error - The error details to be logged.
 */
export const logError = (title: string, error: unknown): void => {
  console.error(title, error);
};

/**
 * Type guard to check if the error is a Response object with clone and json methods.
 * @param error - The error to be checked.
 * @returns True if the error is a Response object with clone and json methods, otherwise false.
 */
const isResponseError = (error: unknown): error is Response => {
  return (
    typeof error === 'object' &&
    !!error &&
    'clone' in error &&
    typeof error.clone === 'function' &&
    'json' in error &&
    typeof error.json === 'function'
  );
};

/**
 * Logs a server error, handling different error types such as AxiosError and ResponseError
 * @param error - The error to be logged.
 */
export const logServerError = (error: unknown): void => {
  if (isAxiosError(error)) {
    logError('Server error', error.response?.data);
  } else if (isResponseError(error)) {
    error
      .clone()
      .json()
      .then((errorMessage: unknown) => {
        logError('Server error', errorMessage);
      });
  } else {
    logError('Server error', error);
  }
};
